// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root___a5wp","icon":"SortAdornment_icon__HuQ-K","up":"SortAdornment_up__3fDpQ","down":"SortAdornment_down__1LXJz","active":"SortAdornment_active__3PObD"};